import { create } from 'zustand';

export type TSecondaryHeaderResponse = {
  title: string;
  router: () => void;
};

type TSecondaryHeaderStore = {
  data: TSecondaryHeaderResponse | undefined | null;
  setter: (data?: TSecondaryHeaderResponse | undefined | null) => void;
};

type THeaderSheetOpenStore = {
  data: boolean;
  setter: (data: boolean) => void;
};

export const UseSecondaryHeaderStore = create<TSecondaryHeaderStore>((set) => ({
  data: null,
  setter: (data) => {
    set({ data });
  },
}));

export const useHeaderSheetOpenStore = create<THeaderSheetOpenStore>((set) => ({
  data: false,
  setter: (data) => {
    set({ data });
  },
}));
